import { css, Tag } from '@appd/uik';
import { getSingleTagStyles, HealthStatusLabel } from './getSingleTagStyles';

// import { HealthStatusValue, ScopeUrlUtil, useScope } from '@/modules/shared';

export interface SingleTagProps {
  entityType: string;
  health: string;
  count: number;
  href: string;
}

export const getHealthStatusLabel = (healthStatusCode: string): HealthStatusLabel => {
  if (healthStatusCode === 'null') {
    return HealthStatusLabel.NoAlertRulesEnabled;
  }
  switch (Number(healthStatusCode)) {
    case 0:
      return HealthStatusLabel.Healthy;
    case 2:
      return HealthStatusLabel.Warning;
    case 3:
      return HealthStatusLabel.Unhealthy;
    default:
      return HealthStatusLabel.Unknown;
  }
};

const ICON_MAPPING = {
  [HealthStatusLabel.Unknown]: 'Health.Unknown',
  [HealthStatusLabel.Unhealthy]: 'Health.Critical',
  [HealthStatusLabel.Healthy]: 'Health.Normal',
  [HealthStatusLabel.Warning]: 'Health.Warning',
  // todo this will be updated with new ICON
  [HealthStatusLabel.NoAlertRulesEnabled]: 'Health.NoAlertRulesEnabled',
};

export function SectionCardEntryTag({ health, count, href }: SingleTagProps): JSX.Element {
  const healthStatus = getHealthStatusLabel(health);

  return (
    <a href={href} className={css({ textDecoration: 'none' })}>
      <Tag.Selectable size="MEDIUM" className={getSingleTagStyles(healthStatus)} prefix={ICON_MAPPING[healthStatus]}>
        {count}
      </Tag.Selectable>
    </a>
  );
}
